export default __webpack_public_path__ + "static/media/4699@2x.af9758b0.png";